import apiFetch from '@wordpress/api-fetch';
import { __ } from "@wordpress/i18n";
import { useEffect, useState } from 'react';
import Hint from '../components/Hint/Hint';
import InfoBox from "../components/InfoBox/InfoBox";
import Switch from '../components/Switch/Switch';
import { useMenu } from "../contexts/MenuContext";
import { formDataPost } from "../helpers/Helpers";
import withForm from '../layouts/withForm';
const SecurityErrorNotification = ({handleChange}) => {
    const {
        settingData, 
    } = useMenu();

    const [adminEmails, setAdminEmails] = useState(null);   
    useEffect(() => {
        const fetchAdminEmails = async () => {
            try {
                const results = await apiFetch({
                    path: "/ultimate-security/v1/get-admin-emails",
                    method: "GET"
                });        
                // Update state
                setAdminEmails(results);
            } catch (error) {
                // console.error("Error fetching adminEmails:", error);
            }
        };
        fetchAdminEmails();
    }, []);

    const [emailSending, setEmailSending] = useState(false)
    const [emailSend, setEmailSend] = useState(false)
    const [emailError, setEmailError] = useState(null)

    const handleSendEmail = async () => {
        const confirmation = window.confirm(__( "Are you sure you want to proceed?", "ultimate-security" ));
        let result;
        if (confirmation) {            
            setEmailSending(true);
            setEmailError(null);            
            try {
                result = await formDataPost('ultimate_security_send_test_error_email',{'email': settingData?.security?.['email_notification']?.notification_email});
                if (result.success) {
                    setEmailSend(true);
                    setTimeout(() => {
                        setEmailSend(false);
                    }, 3000);
                }
            } catch (error) {
                setEmailError(error.message);
                setEmailSending(false);
            } finally {
                setEmailSending(false);
            }

        }
    }

    return (
        <>

            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Notification Email", "ultimate-security")}</h5>                          
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("You can find these keys in your wp-config file", "ultimate-security")}/>
                                    <select 
                                        className="form-select"
                                        value={settingData?.security?.['email_notification']?.notification_email}
                                        onChange={(e)=> handleChange('security.email_notification.notification_email', e.target.value)}
                                    >
                                        {
                                            Array.isArray(adminEmails) && adminEmails.length > 0  
                                            ? adminEmails.map((email)=> (
                                                <option key={email} value={email}>{__( email, "ultimate-security" )}</option> 
                                                )
                                            )
                                            : <option value="">{__( "Loading...", "ultimate-security" )}</option>
                                        }
                                    </select>
                                </div>
                                <div className="content-below-with-hint mt-2">                                    
                                    <span>{__( "Get error notifications in this email.", "ultimate-security" )}</span>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="setting-unit pb-lg mb-lg border-bottom">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Send Test Email", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Test if you are receiving the error emails.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">
                        <div className="row justify-content-between">
                            <div className="col-lg-10">                                
                                <div className="d-flex align-items-center gap-2">                                      
                                    <Hint position="top" content={__("Send a test message with dummy information.", "ultimate-security")}/>                                  
                                    <button 
                                        className="button button-primary"
                                        onClick={handleSendEmail}
                                        disabled={emailSending}
                                    >
                                        {emailSending ? __( "Sending...", "ultimate-security" ) : __( "Send Test", "ultimate-security" )}                                                
                                    </button>
                                    {emailSending && <span className="lds-ring"><span></span><span></span><span></span><span></span></span>}
                                    {emailSend && <img src={ultimate_security_ajax_obj.imageUrl+'success-tick.svg'}/>}
                                </div>
                                <div className="content-below-with-hint mt-2">
                                    <InfoBox className="small-infobox mt-2" title={__( "Note", "ultimate-security" )} content={__( "Don't forget to check your spam emails.", "ultimate-security" )} />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>            
            <div className="setting-unit">
                <div className="row">
                    <div className="col-lg-5">
                        <div className="title-group">
                            <h5 className="pl-heading-1 fw-600 text-text">{__("Error Levels To Notify", "ultimate-security")}</h5>
                            <p className="pl-body text-text">{__("Select from the list what error messages you want to be notified via email.", "ultimate-security")}</p>                            
                        </div>
                    </div>
                    <div className="col-lg-7">

                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_ERROR", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.1"
                                    checked={settingData?.security?.['email_notification']?.levels?.[1]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_WARNING", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.2"
                                    checked={settingData?.security?.['email_notification']?.levels?.[2]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_PARSE", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.4"
                                    checked={settingData?.security?.['email_notification']?.levels?.[4]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_NOTICE", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.8"
                                    checked={settingData?.security?.['email_notification']?.levels?.[8]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_USER_ERROR", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.256"
                                    checked={settingData?.security?.['email_notification']?.levels?.[256]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_USER_WARNING", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.512"
                                    checked={settingData?.security?.['email_notification']?.levels?.[512]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_STRICT", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.2048"
                                    checked={settingData?.security?.['email_notification']?.levels?.[2048]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        <div className="row justify-content-between">
                            <div className="col-lg-10">
                                <div className="title-group d-flex align-items-center ">
                                    <Hint position="top" content={__("Enable/Disable this error.", "ultimate-security")}/>
                                    <h6 className="pl-heading-1 fw-600 text-text">{__("E_DEPRECATED", "ultimate-security")}</h6>
                                </div>
                            </div>                            
                            <div className="col-auto">
                                <Switch 
                                    name="security.email_notification.levels.8192"
                                    checked={settingData?.security?.['email_notification']?.levels?.[8192]} // Pass "1"/"0" from API 
                                    onChange={handleChange}
                                    valueType="string" 
                                />
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}
export default withForm(SecurityErrorNotification, 'security.email_notification');